<template>
  <mf-tooltip :top="alignTop" :bottom="alignBottom" :left="alignLeft" :right="alignRight" max-width="192px" :disabled="disabled" :variant="variant">
    <template v-slot:activator="{ on }">
      <div :style="fitContentClass" v-on="on">
        <slot></slot>
      </div>
    </template>
    <span>{{ message }}</span>
  </mf-tooltip>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    align: {
      type: String,
      default: 'top',
    },
    fitContent: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
  },
  computed: {
    alignTop() {
      return this.align === 'top'
    },
    alignBottom() {
      return this.align === 'bottom'
    },
    alignRight() {
      return this.align === 'right'
    },
    alignLeft() {
      return this.align === 'left'
    },
    fitContentClass() {
      return this.fitContent ? { width: 'fit-content' } : null
    },
  },
}
</script>
